import { Controller } from 'stimulus'
import AirDatepicker from 'air-datepicker'
import 'air-datepicker/air-datepicker.css'
import './date_time_picker_component.scss'
import { uniq } from 'lodash-es'
import getLocale from '~/controllers/booking/air_datepicker_locales'
import { isDesktopView } from '~/controllers/booking/helpers'

export default class extends Controller {
  static values = {
    inline: Boolean,
    pickTime: Boolean,
    restrictedByEnabledDates: Boolean,
    locale: String,
    firstDayOfWeek: Number,
    initialDate: Number,
  }

  connect() {
    this.viewDateChangedListeners = []
    this.dateSelectListeners = []
    this.locale = getLocale(this.localeValue.split('-')[0])

    const pickerOptions = {
      inline: this.inlineValue,
      locale: this.locale,
      toggleSelected: false,
      nextHtml: '<i class="fa-solid fa-chevron-right fa-sm"></i>',
      prevHtml: '<i class="fa-solid fa-chevron-left fa-sm"></i>',
      timepicker: this.pickTimeValue,
      firstDay: this.firstDayOfWeekValue,
      classes: this.restrictedByEnabledDatesValue
        ? 'restricted-by-enabled-dates'
        : '',
      onRenderCell: ({ date, cellType }) => {
        if (cellType === 'day' && this.restrictedByEnabledDatesValue) {
          return { disabled: !this.isEnabled(date) }
        }
      },
      onChangeViewDate: ({ month, year }) => {
        this.viewDateChangedListeners.forEach((cb) =>
          cb(new Date(year, month, 1))
        )
      },
      onSelect: ({ date }) => {
        this.dateSelectListeners.forEach((cb) => cb(date))
        // On mobile we have to unselect it, otherwise if you hit the back button on step two
        // you cannot select the same date again
        if (!isDesktopView()) {
          this.picker.clear({ silent: true })
        }
      },
    }

    // Set initial/start date if provided. Used in tests when we freeze time 🥶
    if (this.hasInitialDateValue && this.initialDateValue) {
      pickerOptions.startDate = new Date(this.initialDateValue * 1000)
    }

    this.picker = new AirDatepicker(this.element, pickerOptions)
  }

  setEnabledDates(dates) {
    this.enabledDates = uniq(dates.map((d) => this.normalizeDateToString(d)))
    this.picker.update({})
    if (this.element.querySelector('.-day-.-disabled-.-selected-')) {
      this.picker.clear()
      this.picker.update({})
    }
  }

  gotoDate(date) {
    this.picker.setViewDate(date)
  }

  getViewDate() {
    return this.picker.viewDate
  }

  getSelectedDate() {
    return this.picker.selectedDates[0]
  }

  onViewDateChanged(cb) {
    this.viewDateChangedListeners.push(cb)
  }

  onDateSelect(cb) {
    this.dateSelectListeners.push(cb)
  }

  unselect() {
    this.picker.clear({ silent: true })
  }

  isEnabled = (date) => {
    return this.enabledDates?.includes(this.normalizeDateToString(date))
  }

  normalizeDateToString(date) {
    if (!date) return null
    if (typeof date === 'string') return date
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
  }
}
